var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgArckPremium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 40C31.0457 40 40 31.0457 40 20C40 8.95431 31.0457 0 20 0C8.95431 0 0 8.95431 0 20C0 31.0457 8.95431 40 20 40Z",
    fill: "#FFAB57"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.2337 28.7644L14.0885 21.8767L18.1277 25.9121L11.2337 28.7644ZM20.5327 27.5496L22.1206 23.6988L16.2115 17.8024L12.3547 19.401L9.33691 16.3835L27.7452 9.33789L30.6633 12.2533L23.6234 30.6643L20.5327 27.5496Z",
    fill: "#FDE78B"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArckPremium);
export default __webpack_public_path__ + "static/media/arck-premium.2ba524430a7f1f283c0f9f68fedb1fd3.svg";
export { ForwardRef as ReactComponent };